import React from 'react';
import { useSelector } from 'react-redux';
import { Box, CircularProgress } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import { useTranslation } from 'react-i18next';
import Typography from '@src/new-components/Typography';
import { AUTO_SAVE_STATUS } from '@src/constants/project';
import Tooltip from '@src/components/Tooltip';
import { COLOR } from '@src/styles/color';

const ROW_SX = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  color: COLOR.label2[64],
};

const AutoSaveStatus = () => {
  const { t } = useTranslation();
  const status = useSelector((s) => s.project.autoSaveStatus);

  switch (status) {
    case AUTO_SAVE_STATUS.SAVING:
      return (
        <Box component="span" sx={ROW_SX}>
          <CircularProgress size={12} thickness={5} />
          <Typography variant="body-12-regular" component="span">
            {t('saving')}
          </Typography>
        </Box>
      );

    case AUTO_SAVE_STATUS.SAVED:
      return (
        <Box component="span" sx={ROW_SX}>
          <CheckCircleRoundedIcon
            sx={{ fontSize: 12, color: 'success.main' }}
          />
          <Typography variant="body-12-regular" component="span">
            {t('autoSaved')}
          </Typography>
        </Box>
      );

    case AUTO_SAVE_STATUS.ERROR:
      return (
        <Tooltip title={t('autoSaveErrorTooltip')} arrow placement="bottom">
          <SaveRoundedIcon sx={{ fontSize: 16, color: 'error.main' }} />
        </Tooltip>
      );

    default:
      return (
        <Tooltip title={t('autoSaveIdleTooltip')} arrow placement="bottom">
          <SaveRoundedIcon sx={{ fontSize: 16, color: COLOR.label2[64] }} />
        </Tooltip>
      );
  }
};

export default AutoSaveStatus;
